import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Box, Dialog, DialogContent, DialogTitle, Grid, Tabs, Tab, TextField, Typography } from '@mui/material';
import { MinimalTeam } from '../types';
import { getTeamMinimalList } from '../teamApi';
import PersonalDataTab from './PersonalDataTab';
import EmployeeStatisticsTab from './EmployeeStatisticsTab';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

type ExportModalProps = {
  isOpen: boolean;
  setIsOpen?: Dispatch<SetStateAction<boolean>>;
  filterOperationalManager?: string;
  filterResidenceGroup?: number;
  filterRegion?: number;
  activeTeams?: boolean;
};

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function ExportModal({
  isOpen,
  setIsOpen,
  filterOperationalManager,
  filterResidenceGroup,
  filterRegion,
  activeTeams,
}: ExportModalProps) {
  const [loadingTeams, setLoadingTeams] = useState(true);
  const [loadingChosenTeams, setLoadingChosenTeams] = useState(true);
  const [teams, setTeams] = useState<MinimalTeam[]>();
  const [chosenTeams, setChosenTeams] = useState<MinimalTeam[]>();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (!isOpen || teams) return;

    getTeamMinimalList({ is_active: activeTeams })
      .then(({ data }) => {
        setTeams(data.data);
      })
      .finally(() => setLoadingTeams(false));
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    if (!filterOperationalManager && !filterResidenceGroup && !filterRegion) {
      setChosenTeams([]);
      setLoadingChosenTeams(false);
      return;
    }

    setLoadingChosenTeams(true);
    getTeamMinimalList({
      filter_operational_manager: filterOperationalManager,
      filter_residence_group: filterResidenceGroup,
      filter_region: filterRegion,
      is_active: activeTeams,
    })
      .then(({ data }) => {
        setChosenTeams(data.data);
      })
      .finally(() => setLoadingChosenTeams(false));
  }, [isOpen, filterOperationalManager, filterResidenceGroup, filterRegion]);

  const handleClose = () => setIsOpen?.(false);

  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth={true} maxWidth="lg">
      <DialogTitle>
        <span className="font-bold text-neutral-600">Dataexport</span>
      </DialogTitle>
      <DialogContent>
        <Grid item>
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange}>
                <Tab
                  // TODO: MUI V5 remove
                  sx={{ '&.Mui-selected': { color: 'black' } }}
                  label="Personuppgifter"
                  {...a11yProps(0)}
                />
                <Tab
                  // TODO: MUI V5 remove
                  sx={{ '&.Mui-selected': { color: 'black' } }}
                  label="Personalomsättning"
                  {...a11yProps(1)}
                />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <PersonalDataTab
                teams={teams}
                chosenTeams={chosenTeams}
                loadingTeams={loadingTeams}
                loadingChosenTeams={loadingChosenTeams}
                handleClose={handleClose}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <EmployeeStatisticsTab
                teams={teams}
                chosenTeams={chosenTeams}
                loadingTeams={loadingTeams}
                loadingChosenTeams={loadingChosenTeams}
                handleClose={handleClose}
              />
            </TabPanel>
          </Box>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
